import { Component, Vue, namespace } from 'nuxt-property-decorator';
import WarRoomUnreadPostsCountQuery from '@/apollo/queries/WarRoomUnreadPostsCount.query';

const updateUnreadPostsInterval = 300000; // 5 mins in ms
const WarRoomStore = namespace('warRoom');

@Component<WarRoomUnreadPostsCountMixin>({
  name: 'WarRoomUnreadPostsCountMixin',
  apollo: {
    warRoomUnreadPostsCount: {
      query: WarRoomUnreadPostsCountQuery,
      error(error): void {
        this.$notice.error(error);
      },
      result({ data }) {
        if (data?.warRoomUnreadPostsCount) {
          this.updateUnreadPostsCount(data.warRoomUnreadPostsCount);
        }
      },
      pollInterval: updateUnreadPostsInterval,
      skip() {
        return !this.$auth.loggedIn;
      },
      prefetch: false,
    },
  },
})
export default class WarRoomUnreadPostsCountMixin extends Vue {
  @WarRoomStore.State('isUnreadPostsLabelActive') isUnreadPostsLabelActive!: boolean;
  @WarRoomStore.State('unreadPostsCount') unreadPostsCount!: number;
  @WarRoomStore.Action('updateUnreadPostsCount') updateUnreadPostsCount!: (unreadPostsCount: number) => void;

  get unreadPostsMessage(): string | null {
    if (this.isUnreadPostsLabelActive && this.unreadPostsCount) {
      return this.unreadPostsCount > 9 ? '9+' : String(this.unreadPostsCount);
    }

    return null;
  }
}
